import { render, staticRenderFns } from "./Number.vue?vue&type=template&id=3f85eb7b&scoped=true"
import script from "./Number.vue?vue&type=script&lang=js"
export * from "./Number.vue?vue&type=script&lang=js"
import style0 from "./Number.vue?vue&type=style&index=0&id=3f85eb7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f85eb7b",
  null
  
)

export default component.exports